import PaymentSummary from './PaymentSummary';

export default PaymentSummary;
